'use strict';

require('./cn-movie-button.scss');

module.exports = {
  template: require('./cn-movie-button.html'),
  controller: require('./cn-movie-button.controller.js'),
  controllerAs: 'vm',

  bindings: {
    videoUrl: '<',
    buttonClass: '<',
    buttonText: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-movie-button/index.js
 ** module id = 68
 ** module chunks = 0
 **/